export default "__VITE_ASSET__HEymw54k__"